// extracted by css-extract-rspack-plugin
export default {"cls1":"Instructor-cls1_GBu","cls2":"Instructor-cls2_FaT Instructor-cls1_GBu"};